import { getBonusTypeColor } from '@/components/Bonus/UserBonus/Card/helper';
import { BonusTypeType } from '@/enums/bonusTypeId';
import { RootState } from '@/lib/store';
import { getContrastColor } from '@/utils/color/getContrastColor';
import { Button } from '@starsoft/common/components';
import { useLottiePlayer } from '@starsoft/common/hooks';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { SportsCardProps } from './props';
import styles from './styles.module.scss';

export default function SportsCard({ userBonus }: SportsCardProps) {
  const { t } = useTranslation('bonus');
  const { push } = useRouter();
  const isAdminView = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/soccer-ticket.json',
    dependecyArray: [],
  });

  function handleNavigate() {
    if (isAdminView) {
      return;
    }

    push('/sports');
  }

  return (
    <div
      className={styles.container}
      style={{
        //@ts-ignore
        '--bonus-color': getBonusTypeColor(
          userBonus?.bonus?.type?.id as BonusTypeType,
        ),
        '--contrast-bonus-color': getContrastColor(
          getBonusTypeColor(userBonus?.bonus?.type?.id as BonusTypeType),
        ),
      }}
    >
      <span className={styles.container__title}>
        {t('play_sportsbook_title')}
      </span>
      <p className={styles.container__description}>
        {t('play_sportsbook_description')}
      </p>
      <Button
        onClick={handleNavigate}
        isSecondary
        useMaxContent
        isSmall
        className={styles.container__button}
      >
        {t('common:play_now')}
      </Button>

      <div className={styles.container__lottie} ref={lottieAnimationRef} />
    </div>
  );
}
